module.exports = "<nav class=\"navbar navbar-toggleable-md navbar-inverse bg-inverse fixed-top\">\n  <div class=\"container\">\n \n        <a class=\"navbar-brand\" href=\"#\">RelativePitch Pro</a>\n\n  </div>\n\n</nav>\n<br>\n<br>\n<br>\n"


//////////////////
// WEBPACK FOOTER
// /Users/ericzayas/Documents/relativePitch/src/app/components/navbar/navbar.component.html
// module id = ../../../../../src/app/components/navbar/navbar.component.html
// module chunks = main